import QuestionPage from './question'
import AskQuestionPage from './askQuestion'
import EditAnswerPage from './editAnswer'

export { QuestionPage, AskQuestionPage, EditAnswerPage }
